import {ANALYZE_POLYGON_POPUP_WIDTH} from 'app/components/AnalyzePolygonPopup/AnalyzePolygonPopup';
import {SIDEBAR_CONTENT_WIDTH, SIDEBAR_WIDTH} from 'app/components/TabbedSidebar/TabbedSidebar';

import {MapInteractionTool} from '../view';

const MARGIN = 10;

/**
 * Left offset for the grid review / size-picker overlay dialog. Keeps the
 * panel clear of the sidebar and any active analyze-polygon popup.
 */
export function gridPanelLeft(
  isSidebarExpanded: boolean,
  activeMapInteractionTool: MapInteractionTool | null
): number {
  if (activeMapInteractionTool === 'analyzePolygon') {
    return SIDEBAR_WIDTH + MARGIN + ANALYZE_POLYGON_POPUP_WIDTH + MARGIN;
  }
  return SIDEBAR_WIDTH + MARGIN + (isSidebarExpanded ? SIDEBAR_CONTENT_WIDTH : 0);
}
